import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgCommandButton = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {
          "\n    Command Button Keyboard Streamline Icon: https://streamlinehq.com\n  "
        }
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M20.05.75H3.95c-1.8 0-3.2 1.4-3.2 3.2v16.1c0 1.8 1.4 3.2 3.2 3.2h16.1c1.8 0 3.2-1.4 3.2-3.2V3.95c0-1.7-1.4-3.2-3.2-3.2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M16.55 14.25c1.2 0 2.2 1.0001 2.2 2.2001s-1 2.1999-2.2 2.1999-2.2-.9999-2.2-2.1999v-9c0-1.2 1-2.2001 2.2-2.2001s2.2 1 2.2 2.2-1 2.2-2.2 2.2h-9c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2v9.0001c0 1.2-1 2.1999-2.2 2.1999s-2.2-.9999-2.2-2.1999 1-2.2001 2.2-2.2001z"
    />
  </svg>
);
export default SvgCommandButton;
